var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 0H3.33333C2.4496 0.00105857 1.60237 0.352588 0.977479 0.977481C0.352588 1.60237 0.00105857 2.44961 0 3.33334L0 11.3333C0.00105857 12.2171 0.352588 13.0643 0.977479 13.6892C1.60237 14.3141 2.4496 14.6656 3.33333 14.6667H12.6667C13.5504 14.6656 14.3976 14.3141 15.0225 13.6892C15.6474 13.0643 15.9989 12.2171 16 11.3333V3.33334C15.9989 2.44961 15.6474 1.60237 15.0225 0.977481C14.3976 0.352588 13.5504 0.00105857 12.6667 0ZM3.33333 1.33334H12.6667C13.0658 1.33412 13.4557 1.45435 13.786 1.67854C14.1162 1.90273 14.3719 2.22063 14.52 2.59134L9.41466 7.69734C9.03895 8.07155 8.53027 8.28166 7.99999 8.28166C7.46972 8.28166 6.96104 8.07155 6.58533 7.69734L1.48 2.59134C1.6281 2.22063 1.88374 1.90273 2.21403 1.67854C2.54432 1.45435 2.93414 1.33412 3.33333 1.33334ZM12.6667 13.3334H3.33333C2.8029 13.3334 2.29419 13.1226 1.91912 12.7476C1.54405 12.3725 1.33333 11.8638 1.33333 11.3333V4.33334L5.64266 8.64001C6.26841 9.26418 7.11617 9.61471 7.99999 9.61471C8.88382 9.61471 9.73157 9.26418 10.3573 8.64001L14.6667 4.33334V11.3333C14.6667 11.8638 14.4559 12.3725 14.0809 12.7476C13.7058 13.1226 13.1971 13.3334 12.6667 13.3334Z",
    fill: "#134A70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.4aa7913aba226abe2d582f08045e3986.svg";
export { ForwardRef as ReactComponent };